import api from './ApiService';

const updateProfile = (data) => api.put('me', data);
const uploadAvatar = (data) => api.post('me/upload-avatar', data);

export default {
  updateProfile,
  uploadAvatar,
};
